import * as $ from 'jquery';
var ComponentHandler = (function () {
    function ComponentHandler() {
        this.instances = [];
    }
    ComponentHandler.prototype.addComponent = function (jsClassName, selector, options) {
        var _this = this;
        if (selector) {
            $(selector).each(function (idx, element) {
                _this.initializeComponent(jsClassName, element, options);
            });
        }
        else {
            this.initializeComponent(jsClassName, null, options);
        }
    };
    ComponentHandler.prototype.destroyAll = function () {
        for (var _i = 0, _a = this.instances; _i < _a.length; _i++) {
            var instance = _a[_i];
            if (typeof instance.destroy === 'function') {
                instance.destroy();
            }
        }
    };
    ComponentHandler.prototype.initializeComponent = function (jsClassName, element, options) {
        var instance = new jsClassName(element, options);
        if (typeof instance.init === 'function') {
            instance.init();
        }
        if (element) {
            $(element).data('instance', instance);
        }
        this.instances.push(instance);
    };
    return ComponentHandler;
}());
export { ComponentHandler };
//# sourceMappingURL=component_handler.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@pixelart/component-handler/dist/component_handler.class.js
// module id = 39
// module chunks = 0